import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

function TopicBanner(props){
  return (
    <div className="topic-topic-banner">
      <img src={props.url} alt=""/>
    </div>
  );
}

TopicBanner.propTypes = {
  topic: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopicBanner);



// WEBPACK FOOTER //
// ./src/features/topic/TopicBanner.js